import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import Button from "../Components/BasicComponents/Button";
import TabBar from "../Components/BasicComponents/TabBar";
import Icon from "../Assets/IconLibrary/Icon";
import {UseCaseList} from "../Components/Contents/UseCaseList";
import {DefaultParameters} from "../Api/ApiCallMethod";
import MetaData from "../Components/MetaData/MetaData";

export default class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userType: [
                {
                    Name: "Enterprise",
                },
                {
                    Name: "Law Firm",
                },

                {
                    Name: "Inventor",
                },
            ],
            activeUserType: {
                Name: "Enterprise",
            },


            enterpriseMode: [
                {
                    Name: "Self-Hosted",
                    Price: 4,
                    Color: "#39D8A8",
                    Note: "Portfolio Pricing"
                },
                {
                    Name: "SAAS",
                    Price: 2.5,
                    Color: "#95C4FF",
                    Note: "Fair Use Policy Applies"
                },
            ],
        }
    }


    onSignUp = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');
    }

    render() {
        return (
            <div className="pricing-plan-layout">
                <MetaData keyword={"pricing"}/>
                <h1 className="section-title">
                    Agentic AI : <u>Best Price</u>. Best Performance. Period.
                </h1>
                <div className="section-description highlighted point-description">
                    We confidently offer the best agentic ai platform at the best price
                    <br/>
                    You can pay monthly or annually or multi-year —whichever suits you best!
                </div>

                <TabBar onChange={(activeTab) => {
                    this.setState({activeUserType: activeTab})
                }}
                        activeTab={this.state.activeUserType}
                        tabList={this.state.userType}/>

                <div className="pricing-plan-division">
                    {
                        this.state.activeUserType.Name === "Enterprise" ?
                            <div className="pp-enterprise-division">
                                <div className="pp-price-info-header">
                                    <div className="pp-price-info-header-label">
                                        Contact:
                                    </div>
                                    <div className="pp-price-info-header-value">
                                        <div className="pp-enterprise-price">
                                            sales@ipagent.ai
                                        </div>
                                    </div>
                                </div>
                                <div className="pp-use-case-list-container">
                                    <div className="landing-use-case-list">
                                        {
                                            Object.keys(UseCaseList).map((useCaseInfo, uid) =>
                                                <button className="landing-use-case-item"
                                                        key={uid}>
                                                    <Icon name={UseCaseList[useCaseInfo].Icon} size={20}
                                                          className="lading-use-case-icon"/>
                                                    <div className="landing-use-case-item-text">
                                                        {UseCaseList[useCaseInfo].Name}
                                                    </div>
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            this.state.activeUserType.Name === "Law Firm" ?
                                <div className="pp-law-firm-division">
                                    <div className="pp-price-info-header">
                                        <div className="pp-price-info-header-label">
                                            Pricing:
                                        </div>
                                        <div className="pp-price-info-header-value">
                                            <div className="pp-enterprise-price">
                                                Per Matter
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pp-use-case-list-container">
                                        <div className="pp-law-firm-use-case-list">
                                            {
                                                Object.keys(UseCaseList).map((useCaseInfo, uid) =>
                                                    UseCaseList[useCaseInfo].SupportLawFirm &&
                                                    <Button className="pp-law-firm-use-case-item"
                                                            key={uid}>
                                                        <Icon name={UseCaseList[useCaseInfo].Icon} size={20}
                                                              className="pp-law-firm-use-case-icon"/>
                                                        <div className="pp-law-firm-use-case-item-info">
                                                            <div className="pp-law-firm-use-case-item-text">
                                                                {UseCaseList[useCaseInfo].Name}
                                                            </div>
                                                            <div
                                                                className="pp-law-firm-use-case-item-price free-ai-agent">
                                                                {UseCaseList[useCaseInfo].Price}
                                                            </div>

                                                        </div>

                                                    </Button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="pp-inventor-division">
                                    <div className="pp-inventor-card">
                                        <Icon name={"patchat"} size={100} className="pp-inventor-card-info-icon"/>
                                        <div className="pp-inventor-card-info">
                                            <div className="pp-inventor-card-price">Free</div>
                                            <div className="pp-inventor-card-title">
                                                Inventor AI Assist
                                            </div>
                                            <div className="pp-inventor-card-body">
                                                <div className="pp-inventor-card-text-row">
                                                    <div className="pp-inventor-card-text-value">10</div>
                                                    Searches / Week
                                                </div>
                                                <div className="pp-inventor-card-text-row">
                                                    <div className="pp-inventor-card-text-value">50</div>
                                                    Searches / Month
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    }
                </div>
                <Button type={"primary"} onClick={this.onSignUp.bind(this)}>
                    Get Started
                </Button>

            </div>
        )
    }

}